import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'useTestData';

const useEnforceTestParam = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    const shouldUseTest = stored === 'true';

    const params = new URLSearchParams(location.search);
    const alreadyHasTestParam = params.get('test') === 'true';

    if (shouldUseTest && !alreadyHasTestParam) {
      params.set('test', 'true');
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }

    if (!shouldUseTest && params.get('test') === 'true') {
      params.delete('test');
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  }, [location.pathname]);
};

export default useEnforceTestParam;
